import Links from './links';

class FaqLink {
  constructor() {
    /**
     * The referred FAQ item
     * 
     * @type {jQuery}
     */
    this.faqItem = null;

    /**
     * Link selector
     * 
     * @type {jQuery}
     */
    this.selector = $('.main a[href*="/faq/"]');
  }
  
  init() {
    if (!$('.faq').length) {
      return;
    }

    /**
     * Functions to run when a link referring to an FAQ item
     * gets clicked on
     * 
     * @listens click
     */
    this.selector.on('click', (event) => {
      event.preventDefault();
      
      this.getFaqItem(event);
      this.scrollToFaqItem();
      this.openFaqItem();
    });
  }

  /**
   * Return the referred to FAQ item
   * 
   * @param {object} event
   * @returns {void}
   */
  getFaqItem(event) {
    const link = event.currentTarget;
    const targetTitle = $(link).text();
    const targetSelector = `.card-title:contains(${targetTitle})`;
    let target = $(targetSelector, $(link).parents('.faq'));

    if (target.length === 0) {
      const faqComponent = $(link).parents('.faq');
      const faqComponentId = faqComponent.attr('id');

      const otherFaqComponentsOnPage = (`.faq[id!=${faqComponentId}]`);
      target = $(targetSelector, otherFaqComponentsOnPage);
    }

    this.faqItem = target.parents('.card');
  }
  
  /**
   * Scroll to the FAQ item
   * 
   * @returns {void}
   */
  scrollToFaqItem() {
    Links.smoothScroll(this.faqItem, 300, 0, true, () => this.openFaqItem());
  }

  /**
   * Open the FAQ item
   * 
   * @returns {void}
   */
  openFaqItem() {
    $('.collapse', this.faqItem).collapse('show');
  }
}

$(document).ready(() => new FaqLink().init());
